import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19.114 5.63623L6.38604 18.3642",
		stroke: "black",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.114 18.3643L6.38603 5.63634",
		stroke: "black",
		strokeWidth: 1.5
	})]
});
export default SvgClose;
